module.exports = __webpack_public_path__ + "fonts/Quarca-NorBol.17915010.woff";